import getApiBaseUrl from "../../utils/api";

const API_URL = getApiBaseUrl();

const inventoryActions = ({ getStore, getActions, setStore }) => ({
  getInventoryHistory: async () => {
    try {
      const { token } = getStore();

      const response = await fetch(`${API_URL}/api/kpis/inventory-history`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      const error = await getActions().handleApiError(response);
      if (error) return null;

      const data = await response.json();

      setStore({
        inventoryHistory: data,
      });

      return data;
    } catch (error) {
      console.error("Inventory history error:", error);
      getActions().showToast("Error cargando historial de inventario", "error");
      return null;
    }
  },
});

export default inventoryActions;
